import React, {useContext, useEffect} from "react";
import moengage from "@moengage/web-sdk";
import { useLocation, useNavigate } from "react-router-dom";
import { GetCustomerDetailsContext } from "../../App";
import rejectedSvg from "../../assets/svg/EPL_think_svg/Folded_Hands.svg";
import Button from "../../components/core/EPL_Button_Think";
import SubTitle from "../../components/core/SubTitle";
import Title from "../../components/core/Title";
import ProgressBar from "../../components/navigation/progress_bar/EPL_ProgressBar";
import { getRouteFromLoanStageService } from "../../shared/services/getRouteFromLoanStageService";
import { AfterLoginLayoutWrapper } from "../_styles/EPL_AfterLoginLayoutWrapper_think";
import { ErrorWrapper } from "./_styles/ErrorWrapper";
import { isStageLogin } from "../../shared/validations/StageLogin";
moengage.initialize({ app_id: "L9SUGRVWTLEJA9UWH2ZEAMHL", cluster: "dc_3" });

function Rejected() {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const source = location.pathname.split("/")[1];
  const [customerDetails, setCustomerDetails] = useContext(
    GetCustomerDetailsContext
  );

  useEffect(() => {
    isStageLogin(
      customerDetails?.Data?.uuid,
      customerDetails?.Data?.mobile,
      customerDetails?.source,
    );

    const message = customerDetails.Data.message;
    const cleanedMessage = message.replace(/[A-Z0-9]{10}/, "");
    // console.log(cleanedMessage);

    setTimeout(function () {
      moengage.track_event("rejection", {
        rejection_status: true,
        rejection_message: cleanedMessage,
        journey_name: customerDetails.source,
      });
    }, 1000);
    if (sessionStorage.getItem("redirectUrl") != "null" && sessionStorage.getItem("redirectUrl") != "") {
      window.open(sessionStorage.getItem("redirectUrl"), "_self");
    }
  }, []);

  return (
    <>
      <ProgressBar showProgress={false} currentStep={0} />
      <AfterLoginLayoutWrapper>
        <ErrorWrapper className="first-child">
          <Title
            id="pageTitle"
            className="pageTitle"
            text={`We are sorry!`}
            visible={true}
            clickable={false}
            style={{
              fontSize: "24px",
            }}
          />
          <div style={{
            padding: "0px 10px",
            margin: "20px",
            // backgroundColor: "red",
            textAlign: "center",
          }}>
            <SubTitle 
              id="pageSubTitle"
              className="pageSubTitle"
              text={"We are unable to process your loan application further."}
              style={{
                fontSize: "20px",
              }}
            />
          </div>
          <div className="image">
            <img height={125} width={131} src={rejectedSvg} alt="ABCL_Application_Rejected" />
          </div>
        </ErrorWrapper>
        <div className="bottomDiv only-btn">
          <Button
            id="ProceedBtn"
            className="Btn ProceedBtn"
            disabled={false}
            onClick={() => {
              const updated = customerDetails;
              updated.stage = "";
              updated.Data = null;
              updated.application_form_number = null;
              setCustomerDetails({
                ...updated,
              });
              var route = getRouteFromLoanStageService({
                source: source,
                stage: "",
              });
              // // console.log("stage: ", customerDetails.stage);
              // console.log("route: ", route);
              if (sessionStorage.getItem("urlParams")) {
                // if (searchParams.getItem("dsa_hash")) {
                const url = `${route}${sessionStorage.getItem("urlParams")}`
                navigate(url , {
                  replace: true,
                });
              }
              else {
                const url = `${route}`
                navigate(url, {
                  replace: true,
                });
              }
            }}
            text={"Home"}
          />
        </div>
      </AfterLoginLayoutWrapper>
    </>
  );
}

export default Rejected;
